export enum DocTypes {
    PROOF_OF_ASSETS = 'PROOF_OF_ASSETS',
    BASIC_AGREEMENT = 'BASIC_AGREEMENT',
    APPLICATION = 'APPLICATION',
    ADVISORY = 'SET_BASIC_DOCS',
    GENERATE = 'GENERATE',
    NOT_AVAILABLE = 'NOT_AVAILABLE',
    EMPTY_FORM = 'EMPTY_FORM',
    ID_DOCUMENT = 'ID_DOCUMENT',
    INVESTOR_PROFILE_DOC = 'INVESTOR_PROFILE_DOC',
}

export enum ApplicationStatus {
    inProgress = 0,
    completed = 1,
    canceled = 2,
    readyForSign = 3,
    submitted = 4,
    readyForSubmit = 5,
    closed = 6,
    readyForIbanReservation = 7,
    documentGenerationFailed = 8,
    expired = 9,
    deleted = 10,
    revoked = 11,
    advisoryInReview = 9999999,
}

export enum CaseOrderStatus {
    Created = 1,
    ReadyForSigning = 2,
    ReadyToSubmit = 3,
    Submitted = 4,
    Cancelled = 5,
}

export enum SubmittedCaseOrderStatus {
    inProgress = 'inProgress',
    forSignature = 'forSignature',
    submitted = 'submitted',
    accepted = 'accepted',
    finished = 'finished',
    rejected = 'rejected',
    aborted = 'aborted',
    expirted = 'expirted',
    systemError = 'systemError',
    error = 'error',
}

export type TOnSignFileData = {
    file: File | File[];
    contactId?: number;
    originOfAsset?: number;
    documentId: number;
    type: DocTypes;
};

export enum POLLING_STATUS {
    notFound = 'NotFound',
    inProgress = 'InProgress',
    error = 'Error',
    success = 'Success',
}

export enum DocStatus {
    ReadyToGenerate = 'ready-to-generate',
    ReadyToSubmit = 'ready-to-submit',
    ReadyToSign = 'ready-to-sign',
    Canceled = 'canceled',
    Error = 'error',
    Loading = 'loading',
    Disabled = 'disabled',
    ReadyToUpload = 'ready-to-upload',
    ReadyToReUpload = 'ready-to-re-upload',
}

export enum DocSignStatus {
    outOfScope = 1,
    notSigned = 2,
    esignInProgress = 3,
    signed = 4,
}

export interface EmptyFormDocumentDownloadPayload {
    documentReferenceId: string;
    portfolioId: number;
    contactId: number;
    triggerRetentionEmail: boolean;
}

export interface DocBoxProps {
    type: DocTypes;
    status?: ApplicationStatus;
    uploadStatus?: DocStatus;
    documentName?: string;
    className?: string;
    documentId?: number;
    originOfAsset?: number;
    contactId?: number;
    applicationId?: number;
    isSent?: boolean;
    isSentCase?: boolean;
    allowSigning?: boolean;
    applicationExpired?: boolean;
    canESign?: boolean;
    isCaseDetails?: boolean;
    isDocReUploadInProgress?: boolean;
    is3aVB?: boolean;
    isApplicationClosed?: boolean;
    isFollowUpInvestorProfile?: boolean;
    isDocGenerationInProgress?: boolean;
    acceptDocumentSend?: (payload: { documentId: number }) => Promise<void>;
    onManualSign?: (d: TOnSignFileData) => Promise<void>;
    onESign?: (d: { documentId: number }) => Promise<void>;
    onDocGeneration?: (d: {
        applicationId: number;
        applicationStatus?: ApplicationStatus;
        is3aVB?: boolean;
    }) => Promise<void>;
    setRetryState?: (d: { applicationId: number }) => void;
    handleDocReUpload?: (documentId: number) => void;
    onPlanDataChangeFormModalShow?: () => void;
    onAdvisoryDocReUpload?: ({
        filename,
        file,
        containerId,
    }: {
        filename: string;
        file: File;
        containerId?: string;
    }) => void;
    canReUpload?: boolean;
    onDocGenerationWithNewAPI?: (d: {
        applicationId: number;
        applicationStatus?: ApplicationStatus;
        is3aVB?: boolean;
    }) => Promise<void> | undefined;
}

export const applicationStatusIgnoreListForReUpload = [
    ApplicationStatus.completed,
    ApplicationStatus.canceled,
    ApplicationStatus.submitted,
    ApplicationStatus.closed,
    ApplicationStatus.revoked,
    ApplicationStatus.deleted,
    ApplicationStatus.expired,
];
